import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { 
  BriefcaseFill, 
  Envelope, 
  People, 
  Shield,
  PersonCheck,
  Briefcase,
  CalendarEvent,
  PersonVcard,
  FileText,
  BarChart,
  XCircle,
  Cloud,
  Globe,
  EnvelopeAt,
  Activity,
  ArrowClockwise,
  Share
} from 'react-bootstrap-icons';

const Dashboard: React.FC = () => {
  return (
    <Container fluid className="py-4">
      <h1 className="mb-4">Dashboard</h1>
      
      <Row className="g-4">
        {/* CRM Section */}
        <Col xs={12} lg={6}>
          <Card className="h-100">
            <Card.Header className="d-flex align-items-center">
              <BriefcaseFill className="me-2" size={20} />
              <h5 className="mb-0">CRM</h5>
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                <Col xs={6}>
                  <Link to="/leads" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <PersonCheck className="me-2" size={18} />
                    <span>Leads</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/deals" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Briefcase className="me-2" size={18} />
                    <span>Deals</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/meetings" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <CalendarEvent className="me-2" size={18} />
                    <span>Meetings</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/contacts" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <PersonVcard className="me-2" size={18} />
                    <span>Contacts</span>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* EMM Section */}
        <Col xs={12} lg={6}>
          <Card className="h-100">
            <Card.Header className="d-flex align-items-center">
              <Envelope className="me-2" size={20} />
              <h5 className="mb-0">EMM (Email Marketing)</h5>
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                <Col xs={6}>
                  <Link to="/emm-dashboard" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Envelope className="me-2" size={18} />
                    <span>EMM Dashboard</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/campaigns" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Envelope className="me-2" size={18} />
                    <span>Campaigns</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/unibox" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Envelope className="me-2" size={18} />
                    <span>Unibox</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/templates" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <FileText className="me-2" size={18} />
                    <span>Templates</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/subscribers" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <People className="me-2" size={18} />
                    <span>Subscribers</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/analytics" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <BarChart className="me-2" size={18} />
                    <span>Analytics</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/block-list" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <XCircle className="me-2" size={18} />
                    <span>Block List</span>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/* ERM Section */}
        <Col xs={12} lg={6}>
          <Card className="h-100">
            <Card.Header className="d-flex align-items-center">
              <People className="me-2" size={20} />
              <h5 className="mb-0">ERM (Employee Relationship Management)</h5>
            </Card.Header>
            <Card.Body>
              <p className="text-muted mb-0">Coming soon...</p>
            </Card.Body>
          </Card>
        </Col>

        {/* IDM Section */}
        <Col xs={12} lg={6}>
          <Card className="h-100">
            <Card.Header className="d-flex align-items-center">
              <Shield className="me-2" size={20} />
              <h5 className="mb-0">IDM (Identity Management)</h5>
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                <Col xs={6}>
                  <Link to="/aws-accounts" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Cloud className="me-2" size={18} />
                    <span>Hosting Management</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/domains" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Globe className="me-2" size={18} />
                    <span>Domains</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/email-accounts" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <EnvelopeAt className="me-2" size={18} />
                    <span>Email Accounts</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/rotation-scheduling" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <ArrowClockwise className="me-2" size={18} />
                    <span>Rotation</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/cross-identity" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Share className="me-2" size={18} />
                    <span>Cross-Identity</span>
                    </div>
                  </Link>
                </Col>
                <Col xs={6}>
                  <Link to="/health-monitoring" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center p-2 rounded hover-bg">
                    <Activity className="me-2" size={18} />
                    <span>Health Monitor</span>
                    </div>
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <style>{`
        .hover-bg:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
      `}</style>
    </Container>
  );
};

export default Dashboard;

